import clsx from "clsx";
import { STATUS_DOT_CLASS } from "../constants";
import type { DiffStatusChipProps } from "./types";

export const DiffStatusChip = ({
  label,
  count,
  status,
  isSelected,
  onSelect,
}: DiffStatusChipProps) => {
  const isEmpty = count === 0;

  return (
    <button
      type="button"
      onClick={onSelect}
      disabled={isEmpty}
      aria-pressed={isSelected}
      className={clsx(
        "flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs transition-colors",
        isEmpty && "cursor-not-allowed opacity-40",
        isSelected && !isEmpty
          ? "border-blue-300 bg-blue-50 font-medium text-blue-700"
          : "border-gray-200 text-gray-600 hover:bg-gray-50",
      )}
    >
      {status !== undefined && (
        <span
          className={clsx("h-1.5 w-1.5 rounded-full", STATUS_DOT_CLASS[status])}
        />
      )}
      {label}
      <span className={clsx(!isSelected && "text-gray-500")}>{count}</span>
    </button>
  );
};
